// @ts-nocheck
/**
 * Utilidades compartidas para los steps del Lens Configurator
 * Expuestas en window.LensStepUtils para uso en scripts que no usan módulos
 */
(function () {
  function getShopifyDomainFromConfigurator(configurator) {
    if (configurator && configurator.shopDomain) return configurator.shopDomain;
    if (window.__AINY_SHOP_DOMAIN) return window.__AINY_SHOP_DOMAIN;
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }
    return 'gf7q0f-ma.myshopify.com';
  }

  function buildProductsUrl(shopDomain, limit = 250) {
    return `https://${shopDomain}/products.json?limit=${limit}`;
  }

  // Simple in-memory cache por URL durante la carga de la página
  const _productCache = {};
  async function fetchProducts(url) {
    try {
      if (_productCache[url]) {
        return _productCache[url];
      }
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      const data = await res.json();
      const products = data.products || [];
      _productCache[url] = products;
      return products;
    } catch (err) {
      console.error('LensStepUtils.fetchProducts error:', err);
      return [];
    }
  }

  async function fetchProductsByTag(configurator, tag, limit = 250) {
    const domain = getShopifyDomainFromConfigurator(configurator);
    const url = buildProductsUrl(domain, limit);
    // tag puede ser string o array
    const tags = Array.isArray(tag) ? tag : (tag ? [tag] : []);
    console.log('LensStepUtils: fetching products from', url, 'filter tags:', tags);
    const products = await fetchProducts(url);
    if (!tags || tags.length === 0) return products;

    // Normalizar y hacer match case-insensitive
    const lowerTags = tags.map(t => String(t).toLowerCase());
    const matched = products.filter(p => {
      if (!p) return false;
      const productTags = (p.tags || '').toString().toLowerCase();
      return lowerTags.some(t => productTags.includes(t));
    });

    // Debug: mostrar algunos productos encontrados (handles y tags)
    try {
      console.debug('LensStepUtils: products fetched count=', products.length, 'matched=', matched.length);
      if (matched.length > 0) {
        console.debug('LensStepUtils: sample matched products:', matched.slice(0,5).map(p => ({handle: p.handle, tags: p.tags})));
      } else {
        console.debug('LensStepUtils: no matched products for tags', tags);
      }
    } catch (e) { /* ignore debug errors */ }

    return matched;
  }

  function parsePrice(product) {
    try {
      if (!product || !product.variants || product.variants.length === 0) return 0;
      const v = product.variants[0];
      if (v && v.price) return parseFloat(v.price);
    } catch (e) { /* ignore */ }
    return 0;
  }

  window.LensStepUtils = {
    getShopifyDomainFromConfigurator,
    buildProductsUrl,
    fetchProducts,
    fetchProductsByTag,
    parsePrice
  };
})();
